function CircleDT(c, r) {
    this.center = c;
    this.radius = r;
}
CircleDT.prototype = {
    clone: function() {
        return new CircleDT(this.center.clone(), this.radius);
    },

    toString: function() {
        return " Circle[" + this.center.toString() + "|" + this.radius + "|" + Math.round(Math.sqrt(this.radius)) + "]";
    }
};

export default CircleDT;